export default class IconsHelper {
  public static getLogoPath(name: string, withoutTextIfExists?: boolean) {
    switch (name) {
      case 'Triggerbee': {
        return '/assets/img/logos/triggerbe-black-bullet.png';
      }
      case 'Pipedrive': {
        return '/assets/img/logos/pipedrive-logo-bullet.png';
      }
      case 'RuleMailer':
      case 'Rule': {
        if (withoutTextIfExists === true) {
          return '/assets/img/icons/rule-icon.png';
        }
        return '/assets/img/logos/rule-logo.png';
      }
      case 'Mailchimp':
      case 'MailChimp': {
        return '/assets/img/logos/mailchimp_freddie_color_web.png';
      }
      case 'MailerLite': {
        return '/assets/img/logos/mailerlite.png';
      }
      case 'Apsis': {
        return '/assets/img/logos/apsis.png';
      }
      case 'ApsisOne': {
        return '/assets/img/logos/apsis.png';
      }
      case 'Zapier': {
        return '/assets/img/logos/zapier.png';
      }
      case 'Voyado': {
        return '/assets/img/logos/voyado.png';
      }
      case 'Klaviyo': {
        return '/assets/img/logos/klaviyo.svg';
      }
      case 'Emarsys': {
        return '/assets/img/logos/emarsys.png';
      }
      case 'Custobar': {
        return '/assets/img/logos/custobar.png';
      }
      case 'MailerSend': {
        return '/assets/img/logos/mailer_send.svg';
      }
      case 'Centra': {
        return '/assets/img/logos/centra.png';
      }
      case 'Shopify': {
        return '/assets/img/logos/shopify_glyph.png';
      }
      case 'Brevo': {
        return '/assets/img/logos/brevo.jpg';
      }
      case 'Dotdigital': {
        return '/assets/img/logos/dotdigital.png';
      }
      case 'Omnisend': {
        return '/assets/img/logos/omnisend.png';
      }
      case 'CleverReach': {
        return '/assets/img/logos/cleverreach.svg';
      }
      case 'Shopware': {
        return '/assets/img/logos/shopware.svg';
      }
      case 'Custom': {
        return '/assets/img/http.svg';
      }
      default: {
        return '/assets/img/logos/triggerbe-black-bullet.png';
      }
    }
  }
}
